import SendRounded from "@mui/icons-material/SendRounded";
import { IconButton } from "@mui/material";

interface ChatInputAreaSendButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isActive?: boolean;
}

export const ChatInputAreaSendButton = ({
  onClick,
  disabled = false,
  isActive = false,
}: ChatInputAreaSendButtonProps) => (
  <IconButton
    onClick={onClick}
    disabled={disabled}
    size="small"
    data-ph-capture-attribute-action="send_ai_message"
    sx={{
      bgcolor: isActive ? "primary.main" : "transparent",
      color: isActive ? "white" : "text-text-disabled",
      "&:hover": {
        bgcolor: isActive ? "primary.main" : "transparent",
        opacity: isActive ? "0.5" : "1",
      },
      "&.Mui-disabled": {
        color: "text-text-disabled",
      },
    }}
  >
    <SendRounded fontSize="small" />
  </IconButton>
);
